import axios from "axios";
import { CreateReportRequest } from "./dto/Report";

export const createReport = async (
  req: CreateReportRequest
): Promise<void> => {
  await axios.post<CreateReportRequest>("/api/report", req, {
    headers: {
      "Content-Type": "application/json;charset=utf-8",
    },
  });
};
